import { DATE_MOVE_SUFFIX, TYPE_UK_ADDRESS } from '../../utils/constants';
import { checkValue } from '../../utils';

export const renderAddressOrMoveDate = (officer, isAddress) => {
  const noOfAddress = Object.keys(officer).filter(
    v => v !== `${TYPE_UK_ADDRESS}${DATE_MOVE_SUFFIX}` && v.indexOf(DATE_MOVE_SUFFIX) > -1
  );
  return (
    noOfAddress &&
    noOfAddress.map((value, index) => {
      const addressKey = `${TYPE_UK_ADDRESS}${index + 1}`;
      const eleConfig = getDetails(isAddress, addressKey);
      return {
        key: `${eleConfig.title} ${index + 1}`,
        value: isAddress ? getAvailableAddress(officer[addressKey]) : getDateMove(officer[value])
      };
    })
  );
};

const getDetails = (isAddress, addressKey) => ({
  elementKey: isAddress ? `address${addressKey}` : `date${addressKey}`,
  title: isAddress ? 'Previous address' : 'Date move'
});

export const getDateMove = dateMove =>
  dateMove
    ? `${Object.values(dateMove)
        .toString()
        .replace(',', '/')}`
    : '';

export const getAvailableAddress = data => {
  return getSpittedAddress(data.givenAddress ? getDisplayAddress(data.givenAddress) : '');
};

const getSpittedAddress = value => {
  return value
    ? value.split(',').reduce((p = '', val) => {
        return `${p} \n
            ${val}
          `;
      })
    : '';
};

export const getDisplayAddress = customerAddress => {
  if (customerAddress && !customerAddress.address_line1) {
    const houseNo = customerAddress.hasOwnProperty('house_number') && customerAddress.house_number;
    const addressPrefix =
      customerAddress.hasOwnProperty('address_prefix') && customerAddress.address_prefix;
    const street = customerAddress.hasOwnProperty('street') && customerAddress.street;
    const city = customerAddress.hasOwnProperty('city') && customerAddress.city;
    const postcode = customerAddress.hasOwnProperty('postal_code') && customerAddress.postal_code;
    const county = customerAddress.hasOwnProperty('county') && customerAddress.county;
    const houseName = customerAddress.hasOwnProperty('house_name') && customerAddress.house_name;
    const addressLine2 =
      customerAddress.hasOwnProperty('house_name') && customerAddress.address_line2;
    const organisationName =
      customerAddress.hasOwnProperty('organisation_name') && customerAddress.organisation_name;
    const firstLineAddress = !houseName && organisationName ? organisationName : houseName;
    const secondLineAddress = !street && addressLine2 ? addressLine2 : street;
    return `${checkValue(`${addressPrefix} ${firstLineAddress}`)}${checkValue(
      `${houseNo} ${secondLineAddress}`
    )}${checkValue(city)}${checkValue(county)}${checkValue(postcode).replace(',', '')}`;
  }
  return getInternationAddress(customerAddress);
};

const getInternationAddress = address => {
  if (address.address_line1) {
    return `${checkValue(`${address.address_line1}`)}${checkValue(
      `${address.address_line2}`
    )}${checkValue(address.address_line3)}${checkValue(address.address_line4)}${checkValue(
      address.country
    ).replace(',', '')}`;
  }
  return '';
};
